import {
  DiscoveryApi,
  FetchApi,
  IdentityApi,
} from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { GithubActionsApi, PipelineRun } from './types';

/**
 * Creating a GithubActionsClient.
 *
 * @public
 */
export class GithubActionsClient implements GithubActionsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.identityApi = options.identityApi;
  }

  async fetch(
    apiPath: string,
    method: string,
    body?: object,
  ): Promise<Response> {
    const baseUrl = await this.discoveryApi.getBaseUrl('neo4j-github-actions');
    const { token } = await this.identityApi.getCredentials();
    const response = await this.fetchApi.fetch(`${baseUrl}/${apiPath}`, {
      method: method,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response;
  }

  async ListWorkflowRuns(name: string): Promise<PipelineRun[]> {
    const response = await this.fetch(
      `list-workflow-runs/${encodeURIComponent(name)}`,
      'GET',
    );
    return response.json();
  }
}
